module.exports = __webpack_public_path__ + "img/NJR-min.ee2fbb3d.png";